// removed by extract-text-webpack-plugin
module.exports = {"sidebarMenu":"_1TL_XfFvELJhRCEBbyp7NL","menuHeader":"gslXX9768CNwrFEvMG-xf","activeLink":"_1srxNnugWtDJHHngahJTTa","subLinks":"_3XdFVcWKbOPdamo8c_DJk-"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PharmacySidebarMenu.scss
// module id = 562
// module chunks = 0